import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _report" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120 report_area" }
const _hoisted_5 = {
  key: 0,
  class: "sub_con_banner"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "link con_list" }
const _hoisted_8 = { class: "sub_page_con_view sign_form join con_write" }
const _hoisted_9 = { style: {"justify-content":"end"} }
const _hoisted_10 = {
  key: 0,
  class: "close_btn_wrap"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "checkbox_wrap" }
const _hoisted_13 = ["for"]
const _hoisted_14 = ["id", "name", "checked", "onClick"]
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "name", "checked", "onClick"]
const _hoisted_17 = ["for"]
const _hoisted_18 = ["id", "name", "checked", "onClick"]
const _hoisted_19 = ["for"]
const _hoisted_20 = ["id", "name", "checked", "onClick"]
const _hoisted_21 = { class: "imp" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "add_wrap imp" }
const _hoisted_24 = ["for"]
const _hoisted_25 = ["id", "onUpdate:modelValue", "onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "checkbox_wrap" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "imp" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "file_wrap" }
const _hoisted_36 = ["for"]
const _hoisted_37 = ["id", "onChange"]
const _hoisted_38 = { class: "file_list" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "file_name" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "btn_wrap _default left_right_btn _1_2" }
const _hoisted_44 = { class: "left" }
const _hoisted_45 = { class: "right" }
const _hoisted_46 = { class: "sub_page_con_view sign_form join" }
const _hoisted_47 = { class: "report_con" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "imp" }
const _hoisted_50 = {
  key: 0,
  class: "p_info"
}
const _hoisted_51 = { class: "btn_wrap _default left_right_btn _1_2" }
const _hoisted_52 = { class: "right" }
const _hoisted_53 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"deco_wrap\" data-v-6141bc22><i class=\"deco_01\" data-v-6141bc22><img src=\"img/report_left_01.png\" data-v-6141bc22></i><i class=\"deco_02 spin_blink1 _small\" data-v-6141bc22><img src=\"img/b_icon_03.png\" data-v-6141bc22></i><i class=\"deco_03 blink_zoom1 _xxsmall\" data-v-6141bc22><img src=\"img/b_icon_04.png\" data-v-6141bc22></i><i class=\"deco_04 blink_blink4 _xxxsmall\" data-v-6141bc22><img src=\"img/b_icon_04.png\" data-v-6141bc22></i><i class=\"deco_05 spin2 _medium\" data-v-6141bc22><img src=\"img/b_icon_03.png\" data-v-6141bc22></i><i class=\"deco_06 spin_blink3 _small\" data-v-6141bc22><img src=\"img/b_icon_01.png\" data-v-6141bc22></i><i class=\"deco_07 blink_zoom4 _small\" data-v-6141bc22><img src=\"img/b_icon_02.png\" data-v-6141bc22></i><i class=\"deco_character\" data-v-6141bc22><img src=\"img/report_icon.png\" data-v-6141bc22></i></div><div class=\"banner_wrap wrap_1120\" data-v-6141bc22><h2 data-v-6141bc22>시민제보창</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1)))
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "성매매 의심 업소 제보", -1)
            ]))]),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: "active"
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "성매매 알선 광고 제보", -1)
            ]))])
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"bread_crumbs\" data-v-6141bc22><a href=\"\" class=\"icon_wrap\" data-v-6141bc22><img src=\"img/home_icon.png\" alt=\"홈\" data-v-6141bc22></a><span class=\"icon_wrap\" data-v-6141bc22><img src=\"img/part_icon.png\" alt=\"시민제보창\" data-v-6141bc22></span><a href=\"\" data-v-6141bc22>시민제보창</a><span class=\"icon_wrap\" data-v-6141bc22><img src=\"img/part_icon.png\" alt=\"성매매 의심 업소 제보\" data-v-6141bc22></span><a href=\"\" data-v-6141bc22>성매매 알선 광고 제보</a><span class=\"icon_wrap\" data-v-6141bc22><img src=\"img/part_icon.png\" alt=\"신고하기\" data-v-6141bc22></span><a href=\"\" data-v-6141bc22>신고하기</a></div>", 1)),
        ($setup.state.step === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                innerHTML: $setup.CommonUtils.decodeContent($setup.state.menuContent)
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _cache[17] || (_cache[17] = _createElementVNode("p", null, "시민제보 처리과정이 궁금하신가요? ", -1)),
                _createVNode(_component_router_link, {
                  to: "/faqList",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.global.setIntroTab(3))),
                  class: "action_btn"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("span", null, "과정 보러가기", -1),
                    _createElementVNode("img", {
                      src: "img/move_btn.png",
                      alt: ""
                    }, null, -1)
                  ]))]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!$setup.state.isShowModal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "part_tit" }, [
                _createElementVNode("span", null, "구분"),
                _createElementVNode("span", { class: "common_style" }, "성매매 알선 광고 제보")
              ], -1)),
              ($setup.state.step === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form_state_list, (form_state, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "report_con",
                          key: index
                        }, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_9, [
                              ($setup.form_state_list.length > 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("button", {
                                      class: "close_btn icon_wrap",
                                      onClick: ($event: any) => ($setup.removeAd(index))
                                    }, [...(_cache[18] || (_cache[18] = [
                                      _createElementVNode("img", {
                                        src: "img/close_02.png",
                                        alt: "닫기"
                                      }, null, -1)
                                    ]))], 8, _hoisted_11)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", _hoisted_12, [
                              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "form_li_tit" }, "분류", -1)),
                              _createElementVNode("label", {
                                for: 'ad1_' + index
                              }, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  id: 'ad1_' + index,
                                  name: 'ad_type_' + index,
                                  checked: form_state.adType === 1,
                                  onClick: ($event: any) => (form_state.adType = 1)
                                }, null, 8, _hoisted_14),
                                _cache[19] || (_cache[19] = _createElementVNode("em", null, null, -1)),
                                _cache[20] || (_cache[20] = _createElementVNode("span", null, "온라인 알선 광고", -1))
                              ], 8, _hoisted_13),
                              _createElementVNode("label", {
                                for: 'ad2_' + index
                              }, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  id: 'ad2_' + index,
                                  name: 'ad_type_' + index,
                                  checked: form_state.adType === 2,
                                  onClick: ($event: any) => (form_state.adType = 2)
                                }, null, 8, _hoisted_16),
                                _cache[21] || (_cache[21] = _createElementVNode("em", null, null, -1)),
                                _cache[22] || (_cache[22] = _createElementVNode("span", null, "지면광고", -1))
                              ], 8, _hoisted_15),
                              _createElementVNode("label", {
                                for: 'ad3_' + index
                              }, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  id: 'ad3_' + index,
                                  name: 'ad_type_' + index,
                                  checked: form_state.adType === 3,
                                  onClick: ($event: any) => (form_state.adType = 3)
                                }, null, 8, _hoisted_18),
                                _cache[23] || (_cache[23] = _createElementVNode("em", null, null, -1)),
                                _cache[24] || (_cache[24] = _createElementVNode("span", null, "불법옥외광고물", -1))
                              ], 8, _hoisted_17),
                              _createElementVNode("label", {
                                for: 'ad4_' + index
                              }, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  id: 'ad4_' + index,
                                  name: 'ad_type_' + index,
                                  checked: form_state.adType === 4,
                                  onClick: ($event: any) => (form_state.adType = 4)
                                }, null, 8, _hoisted_20),
                                _cache[25] || (_cache[25] = _createElementVNode("em", null, null, -1)),
                                _cache[26] || (_cache[26] = _createElementVNode("span", null, "기타", -1))
                              ], 8, _hoisted_19)
                            ]),
                            _createElementVNode("li", _hoisted_21, [
                              _cache[28] || (_cache[28] = _createElementVNode("label", {
                                for: "area_name",
                                class: "form_li_tit"
                              }, "업소명", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "area_name",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((form_state.shopName) = $event),
                                placeholder: "업소명을 입력하세요"
                              }, null, 8, _hoisted_22), [
                                [_vModelText, form_state.shopName]
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_23, [
                              _createElementVNode("label", {
                                for: 'area_address_search' + index,
                                class: "form_li_tit"
                              }, "업소 주소", 8, _hoisted_24),
                              _withDirectives(_createElementVNode("input", {
                                id: 'area_address_search' + index,
                                "onUpdate:modelValue": ($event: any) => ((form_state.zipCode) = $event),
                                readonly: "",
                                type: "text",
                                class: "code",
                                placeholder: "우편번호",
                                onClick: ($event: any) => ($setup.searchAddress(index))
                              }, null, 8, _hoisted_25), [
                                [_vModelText, form_state.zipCode]
                              ]),
                              _createElementVNode("button", {
                                class: "blue_btn",
                                type: "button",
                                onClick: ($event: any) => ($setup.searchAddress(index))
                              }, "검색", 8, _hoisted_26),
                              _withDirectives(_createElementVNode("input", {
                                id: "area_address",
                                "onUpdate:modelValue": ($event: any) => ((form_state.addr) = $event),
                                readonly: "",
                                type: "text",
                                class: "text",
                                placeholder: "주소"
                              }, null, 8, _hoisted_27), [
                                [_vModelText, form_state.addr]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                id: "area_address2",
                                "onUpdate:modelValue": ($event: any) => ((form_state.addrDetail) = $event),
                                type: "text",
                                placeholder: "상세주소"
                              }, null, 8, _hoisted_28), [
                                [_vModelText, form_state.addrDetail]
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_29, [
                              _cache[29] || (_cache[29] = _createElementVNode("label", {
                                for: "area_num",
                                class: "form_li_tit"
                              }, "업소 번호", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "area_num",
                                "onUpdate:modelValue": ($event: any) => ((form_state.shopNumber) = $event),
                                type: "text",
                                placeholder: "업소 번호를 입력하세요"
                              }, null, 8, _hoisted_30), [
                                [_vModelText, form_state.shopNumber]
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_31, [
                              _cache[30] || (_cache[30] = _createElementVNode("label", {
                                for: "area_url",
                                class: "form_li_tit"
                              }, "광고 URL", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "area_url",
                                "onUpdate:modelValue": ($event: any) => ((form_state.adUrl) = $event),
                                type: "text",
                                placeholder: "광고 URL을 입력하세요"
                              }, null, 8, _hoisted_32), [
                                [_vModelText, form_state.adUrl]
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_33, [
                              _cache[31] || (_cache[31] = _createElementVNode("label", {
                                for: "area_num",
                                class: "form_li_tit"
                              }, "내용", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "custom_scroll",
                                name: "",
                                id: "",
                                placeholder: "성매매 의심 정황 : ‘성매매 알선 광고’로 의심되는 정황이 있다면 자세히 적어주세요.",
                                "onUpdate:modelValue": ($event: any) => ((form_state.content) = $event)
                              }, null, 8, _hoisted_34), [
                                [_vModelText, form_state.content]
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_35, [
                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
                              _createElementVNode("label", {
                                for: 'area_file' + index
                              }, [
                                _createElementVNode("input", {
                                  id: 'area_file' + index,
                                  type: "file",
                                  placeholder: "",
                                  accept: "image/*",
                                  multiple: "",
                                  onChange: (event) => $setup.handleFiles(event, form_state)
                                }, null, 40, _hoisted_37),
                                (!$setup.state.isMobile)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하여 첨부해주세요", -1)),
                                      _cache[33] || (_cache[33] = _createElementVNode("span", {
                                        class: "blue_btn",
                                        style: {"display":"flex","justify-content":"center","align-items":"center"}
                                      }, "파일첨부", -1)),
                                      _cache[34] || (_cache[34] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[35] || (_cache[35] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1)),
                                      _cache[36] || (_cache[36] = _createElementVNode("span", {
                                        class: "blue_btn",
                                        style: {"display":"flex","justify-content":"center","align-items":"center"}
                                      }, "파일첨부", -1))
                                    ], 64))
                              ], 8, _hoisted_36),
                              _createElementVNode("div", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form_state.file, (item, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "file",
                                    key: idx
                                  }, [
                                    _createElementVNode("span", {
                                      class: "file_name",
                                      onClick: ($event: any) => ($setup.downloadFile(item.file, item.imgRealName))
                                    }, _toDisplayString(item.imgRealName), 9, _hoisted_39),
                                    _createElementVNode("button", {
                                      class: "file_del icon_wrap",
                                      onClick: ($event: any) => ($setup.fileRemove(item.idx))
                                    }, [...(_cache[37] || (_cache[37] = [
                                      _createElementVNode("img", {
                                        src: "img/close_02.png",
                                        alt: ""
                                      }, null, -1)
                                    ]))], 8, _hoisted_40)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form_state.localFile, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "file",
                                    key: index
                                  }, [
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(item.name), 1),
                                    _createElementVNode("button", {
                                      class: "file_del icon_wrap",
                                      onClick: ($event: any) => ($setup.removeNewFile(form_state.localFile, index))
                                    }, [...(_cache[38] || (_cache[38] = [
                                      _createElementVNode("img", {
                                        src: "img/close_02.png",
                                        alt: ""
                                      }, null, -1)
                                    ]))], 8, _hoisted_42)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        ($setup.state.idx === 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "common_btn w_120",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.addShop && $setup.addShop(...args)))
                            }, "+업소추가"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("button", {
                          class: "common_btn _gray w_120",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.replace('/report?type=2')))
                        }, "목록"),
                        _createElementVNode("button", {
                          class: "common_btn _gray w_120",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.router.go(-1)))
                        }, "취소"),
                        _createElementVNode("button", {
                          class: "common_btn w_120",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.moveStep(1)))
                        }, "다음")
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("ul", null, [
                          ($setup.state.idx === 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                                _cache[40] || (_cache[40] = _createElementVNode("label", {
                                  for: "user_nickname",
                                  class: "form_li_tit"
                                }, "제보자 닉네임", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  id: "user_nickname",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.nickName) = $event)),
                                  type: "text",
                                  placeholder: "작성하지 않을 경우 익명으로 표기됩니다."
                                }, null, 512), [
                                  [_vModelText, $setup.state.nickName]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", _hoisted_49, [
                            _cache[41] || (_cache[41] = _createElementVNode("label", {
                              for: "user_pw",
                              class: "form_li_tit"
                            }, "비밀번호", -1)),
                            _withDirectives(_createElementVNode("input", {
                              id: "user_pw",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.pw) = $event)),
                              type: "password",
                              placeholder: "비밀번호를 입력하세요"
                            }, null, 512), [
                              [_vModelText, $setup.state.pw]
                            ]),
                            ($setup.state.pw.length < 6)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_50, "비밀번호는 최소 6자 이상 입력해주세요."))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"con_info_view\" data-v-6141bc22><div class=\"con_tit\" data-v-6141bc22>센터 지원 안내</div><div class=\"con_desc\" data-v-6141bc22> 다시함께상담센터는 성매매 과정에서 겪은 다양한 어려움과 피해를 함께 나누고, 해결할 수 있도록 돕는 전문 기관입니다.  <br data-v-6141bc22> 법률적 문제부터 심리·정서적인 어려움, 건강 회복까지 상황에 맞는 맞춤형 지원을 제공합니다.  <br data-v-6141bc22> 모든 상담 내용은 비밀보장되며 지원은 무료입니다. 이용자의 선택과 권리를 가장 우선으로 생각하며, 상담을 통해 지원 방향을 함께 결정합니다. <br data-v-6141bc22> 필요하실 때 언제든지 다시함께상담센터가 곁에 있겠습니다. </div><div class=\"con_info\" data-v-6141bc22><p data-v-6141bc22><span data-v-6141bc22><img src=\"img/call_icon.png\" alt=\"\" data-v-6141bc22> 전화번호 </span><a href=\"tel:02-814-3660\" class=\"blue_txt\" data-v-6141bc22>02-814-3660 (09:00~18:00)</a></p><p data-v-6141bc22><span data-v-6141bc22><img src=\"img/talk_icon.png\" alt=\"\" data-v-6141bc22> 카카오톡 채널 </span><a href=\"https://pf.kakao.com/_xguxaku\" class=\"blue_txt\" data-v-6141bc22>다시함께상담센터 (09:00~18:00)</a></p><p data-v-6141bc22><span data-v-6141bc22><img src=\"img/link_icon.png\" alt=\"\" data-v-6141bc22> 홈페이지 상담 게시판 </span><a href=\"http://dasi.or.kr/html/consult/consult.php\" target=\"_blank\" class=\"blue_txt\" data-v-6141bc22> http://dasi.or.kr/html/consult/consult.php </a></p></div></div>", 1))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "left" }, null, -1)),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("button", {
                          class: "common_btn _gray w_120",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.router.replace('/report?type=2')))
                        }, "목록"),
                        _createElementVNode("button", {
                          class: "common_btn _gray w_120",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.moveStep(0)))
                        }, "이전"),
                        _createElementVNode("button", {
                          class: "common_btn w_120",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args))),
                          disabled: !$setup.state.isPossible
                        }, "저장", 8, _hoisted_53)
                      ])
                    ])
                  ], 64))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}